import {
    FETCH_MEDIA_CONTENT,
    FETCH_MEDIA_CONTENT_SUCCESS,
    FETCH_MEDIA_CONTENT_FAILED,
    MEDIA_DELETE__MESSAGE,
    MEDIA_DELETE_MESSAGE_SUCCESS,
    MEDIA_DELETE__MESSAGE_FAILED
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
};

export default function (state = initialState, { type, payload }) {

    switch (type) {
        case FETCH_MEDIA_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_MEDIA_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_MEDIA_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case MEDIA_DELETE__MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case MEDIA_DELETE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case MEDIA_DELETE__MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        default:
            return state;
    }
}
